export const CUSTOM_CITY_OPTION_VALUE = -1;
